import React, { useState, useEffect, Fragment } from 'react';
import {
  Row,
  Input,
  FormGroup,
  CustomInput,
  Button,
  ButtonGroup,
  Form,
  Modal,
  ModalBody,
} from 'reactstrap';
import {
  Colxx,
  Separator,
} from '../../../../../components/common/CustomBootstrap';

import { AxiosAPI, getGroupID } from '../../../../../helpers/AxiosAPI';
import special_offers from '../../../../../assets/special_offers.png';
import {
  gAPI_Property_List,
  postAPI_Create_A_Message,
  postAPI_Create_VocuherWebiste_Ingetration,
} from '../../../../../constants/APIs';
import short from 'short-uuid';
import Axios from 'axios';
import Validation from '../../../../../components/Validation';
const GreetingCode1 = `integration-${short.generate()}-greeting`;
const EyeCatcherCode1 = `integration-${short.generate()}-eyeCatcher`;
const GreetingCode2 = `integration-${short.generate()}-greeting`;
const EyeCatcherCode2 = `integration-${short.generate()}-eyeCatcher`;

let arr = [];
export default function AddVoucherIntregation({ visible, toggle, LoadIntegrations }) {
  const [property, setProperty] = useState([]);
  const [open,setOpen] = useState(false);
  const [msg,setMsg] =useState([]);
  const [inputData, setInputData] = useState({
    GroupId: getGroupID(),
    Name: '',
    Level: 'Group',
    Properties: property,
    SessionTimeoutInSeconds: 600,
    BaseUrl: 'https://www.bookmebob.com',
    HomePageRoute: '/',
    DefaultLanguage: 'en-US',
    DefaultRuleDescription: 'Default',
    DefaultRuleNudges: [
      {
        EyeCatcher: {
          Code: EyeCatcherCode1,
          FilterTags: null,
        },
        Greeting: {
          Code: GreetingCode1,
          FilterTags: null,
        },
        DelayInMilliseconds: 5000,
      },
      {
        EyeCatcher: {
          Code: EyeCatcherCode2,
          FilterTags: null,
        },
        Greeting: {
          Code: GreetingCode2,
          FilterTags: null,
        },
        DelayInMilliseconds: 15000,
      },
    ],
    BotSettings: {
      Name: 'Bob',
      Tagline: 'Hotel Assistant',
      Colours: {
        Header: '#dfce90',
        BotBot: '#ffffff',
        BotUser: '#dfcf92',
        BotButton: '#da291c',
        BotBackground: '#e9eef4',
        HeaderText: '#4a5051',
        BotBotText: '#353f48',
        BotUserText: '#353f48',
        BotButtonText: '#4a5051',
        primaryColor: '#E31B78',
        buttonColor: '#033DA5',
        redeemBar: '#FA8DAB',
        redeemButton: '#F5D2E3',
        buttonTextColor: 'white',
        redeemTextColor: 'black',
        shoppingBar: '#ED187B',
        shoppingBarText: 'white'
      },
      Text: {
        WebPoweredBy1: 'Powered by',
        WebPoweredBy2: 'BookMeBob',
      },
      Urls: {
        Icon: "https://bmbuiassetsprod.blob.core.windows.net/images/special_offers.dd8a7fa3.png",
        CrossIcon: 'https://webchat.bookmebob.com/res/close_cross.png',
        MinimiseIcon: 'https://webchat.bookmebob.com/res/minus.png',
        WebCookies: 'https://www.bookmebob.com/cookies',
        WebPoweredBy: 'https://www.bookmebob.com',
      },
      IsFooterHide: false
    },
  });

  useEffect(() => {
    AxiosAPI({
      method: 'get',
      url: `${gAPI_Property_List}/?group_id=${getGroupID()}`,
    })
      .then((res) => {
        setProperty([...res.data]);
        let lst = [];
        res.data.map((m) =>
          lst.push(m.id));
        setInputData({ ...inputData, Properties: lst });
      })
      .catch((err) => console.error(err));
  }, []);

  const handleNameChange = (e) => {
    e.persist();
    setInputData({ ...inputData, Name: e.target.value });
  };

  const handleCheckChange = (e) => {
    let filterList = [];
    if (inputData.Properties.filter((p) => p === e.target.value).length > 0) {
      filterList = inputData.Properties.filter(f => f !== e.target.value);
    }
    else {
      filterList = inputData.Properties;
      filterList.push(property.filter((p) => p.id === e.target.value)[0].id);
    }
    setInputData({ ...inputData, Properties: filterList });
  };

  const handleSave = async () => {
    /**  When creating a response for a integration, don't need pass a property id*/
    Axios.all([
      AxiosAPI({
        method: 'post',
        url: postAPI_Create_A_Message,
        data: {
          GroupId: getGroupID(),
          Code: GreetingCode1,
          Language: 'en-US',
          Channel: 'VoucherWebsite',
          Default: ['Hi, how can I help?'],
          Overrides: {},
        },
      }),
      AxiosAPI({
        method: 'post',
        url: postAPI_Create_A_Message,
        data: {
          GroupId: getGroupID(),
          Code: EyeCatcherCode1,
          Language: 'en-US',
          Channel: 'VoucherWebsite',
          Default: ['Hi, how can I help?'],
          Overrides: {},
        },
      }),
      AxiosAPI({
        method: 'post',
        url: postAPI_Create_A_Message,
        data: {
          GroupId: getGroupID(),
          Code: GreetingCode2,
          Language: 'en-US',
          Channel: 'VoucherWebsite',
          Default: [
            'Hi, I can help you with bookings or answer any questions you may have.',
          ],
          Overrides: {},
        },
      }),
      AxiosAPI({
        method: 'post',
        url: postAPI_Create_A_Message,
        data: {
          GroupId: getGroupID(),
          Code: EyeCatcherCode2,
          Language: 'en-US',
          Channel: 'VoucherWebsite',
          Default: [
            'Hi, I can help you with bookings or answer any questions you may have.',
          ],
          Overrides: {},
        },
        postAPI_Create_VocuherWebiste_Ingetration,
      }),
      AxiosAPI({
        method: 'post',
        url: postAPI_Create_VocuherWebiste_Ingetration,
        data: inputData,
      }).then((res) => {
        if (res.data.HttpStatusCode !== undefined && res.data.HttpStatusCode === 400 && res.data.Messages !== undefined
          && res.data.Messages !== null && res.data.Messages.length > 0) {
          setMsg(res.data.Messages);
          setOpen(true);
        }
        else {
          toggle();
          setTimeout(() => {
            LoadIntegrations();
          }, 300);
        }
      }
      )
    ])

  };
  return (
    <Fragment>
      <Modal isOpen={visible} toggle={toggle}>
        <ModalBody>
          <Row className="mb-4">
            <Colxx xxs="12">
              <div className="text-center">
                <h6>Connect Vouchers to your website</h6>
                <Separator className="mb-3" />

                <Form>
                  <FormGroup>
                    <Input
                      type="text"
                      name="integrationName"
                      onChange={handleNameChange}
                      placeholder="Enter your website address"
                    />
                  </FormGroup>
                  <FormGroup>
                    <div className='my-2 text-center'><h3>Select your business name</h3> </div>
                    <div className='integration-property text-start'>
                      <div className='row' style={{ textAlign: 'left' }}>
                        {property.map((p, index) => {
                          return (
                            <div className='col-md-6'>
                              <CustomInput
                                key={p.id}
                                type="checkbox"
                                id={index}
                                value={p.id}
                                label={p.name}
                                checked={inputData.Properties.filter((f) => p.id === f).length > 0 ? true : false}
                                onChange={handleCheckChange}
                              />
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  </FormGroup>
                </Form>
                <ButtonGroup className="mb-2" style={{ marginTop: '20px' }}>
                  <Button className="text-white" color="primary" size="xs" onClick={handleSave}>
                    Get Started
                  </Button>
                  <Button size="xs" color="dark" outline onClick={toggle}>
                    Cancel
                  </Button>
                </ButtonGroup>
              </div>
            </Colxx>
          </Row>
        </ModalBody>
      </Modal>
      <Validation open={open} messages={msg} toggle={()=>{setOpen(!open)}}></Validation>
    </Fragment>
  );
}
